import { useMediaQuery } from '@mui/material';
import React from 'react';

export default function LongArrowSvg({ isMobile }) {
  const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  if (isBelowMd) {
    return (
      <svg
        style={{
          marginTop: -10,
          marginBottom: -10,
          marginLeft: 10,
        }}
        width="202"
        height="24"
        viewBox="0 0 202 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M201.061 13.0607C201.646 12.4749 201.646 11.5251 201.061 10.9393L191.515 1.3934C190.929 0.807611 189.979 0.807611 189.393 1.3934C188.808 1.97919 188.808 2.92893 189.393 3.51472L197.879 12L189.393 20.4853C188.808 21.0711 188.808 22.0208 189.393 22.6066C189.979 23.1924 190.929 23.1924 191.515 22.6066L201.061 13.0607ZM0 13.5H200V10.5H0V13.5Z"
          fill="url(#paint0_linear_2010_9619)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2010_9619"
            x1="0"
            y1="12.5"
            x2="107.216"
            y2="12.304"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#734AE2" />
            <stop offset="0.595" stopColor="#FFBC5B" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      style={{
        marginTop: -20,
        marginBottom: -20,
      }}
      width="543"
      height="45"
      viewBox="0 0 543 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M542.121 24.6213C543.293 23.4497 543.293 21.5503 542.121 20.3787L523.029 1.2868C521.858 0.115223 519.958 0.115223 518.787 1.2868C517.615 2.45837 517.615 4.35786 518.787 5.52944L535.757 22.5L518.787 39.4706C517.615 40.6421 517.615 42.5416 518.787 43.7132C519.958 44.8848 521.858 44.8848 523.029 43.7132L542.121 24.6213ZM0 25.5H540V19.5H0V25.5Z"
        fill="url(#paint0_linear_2010_9443)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2010_9443"
          x1="0"
          y1="23"
          x2="289.478"
          y2="21.5713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#734AE2" />
          <stop offset="0.595" stopColor="#FFBC5B" />
        </linearGradient>
      </defs>
    </svg>
  );
}
